const init = () => {

    var currentFieldVal = '';
    var $field = $('#search');
    var $body = $(document.body);
    var $navSearch = $('.c-nav-search');
    var $autocomplete = $navSearch.find('.c-nav-search__autocomplete');
    
    var keys = {
        ESC: 27,
        TAB: 9,
        RETURN: 13,
        UP: 38,
        DOWN: 40
    };

    $field.on('paste keyup', onFieldChange);
    PubSub.subscribe('app:resized', onResize);
    PubSub.subscribe('close-autocomplete', closeAutocomplete);

    PubSub.subscribe('page-dimmer:clicked', onPageDimmerClick);
    function onPageDimmerClick() {
        if ($body.hasClass('autocomplete-open')) {
            closeAutocomplete();
            $field.blur();
        }
    }

    function onResize() {
        // Add a small delay to ensure DOM elements have resized properly
        setTimeout(setAutocompleteWidth, 10);
    }

    function onFieldChange(e) {
        switch (e.which) {
            case keys.RETURN:
                // submit
            break;
            default:
                // all other key input
                getSuggestions();
                break;
        }
    }

    function getSuggestions() {
        
        // value check
        var fieldVal = $field.val();
        if (fieldVal === currentFieldVal) return;
        currentFieldVal = fieldVal;
        if (fieldVal === '') {
            closeAutocomplete();
            return;
        }

        window.app.searchClient.search({
            query: fieldVal,
            attributesToRetrieve: [
                'title',
                'thumbnail',
                'thumbnails',
                'link',
                'type',
                'author',
                'shortDescription',
                'subtitle',
                'initials'
            ],
            filters: 'region:' + window.app.state.region.toUpperCase(),
            facetFilters: ['region:' + window.app.state.region.toUpperCase()]
        }, onResponse);
    }

    function onResponse(response) {
        var maxResults = window.app.state.winWidth >= 768 ? 6 : 3; // tablet breakpoint is 768px
        response.hits = response.hits.slice(0, maxResults);
        window.app.SearchResults.render(response, '.c-nav-search__autocomplete', false, openAutocomplete);
    }

    function closeAutocomplete() {
        $body.removeClass('autocomplete-open');
    }

    function openAutocomplete() {
        setAutocompleteWidth();
        $body.addClass('autocomplete-open');
    }

    function setAutocompleteWidth() {
        // Use 100% width below 650px, calculated width above
        if (window.app.state.winWidth < 650) {
            // Below 650px, use 100% width
            $autocomplete.css('width', '100%');
        } else {
            // Above 650px, calculate width to match search field
            var $nav = $('.c-nav');
            var containerW = $nav.find('.c-nav__container').width();
            var logoOuterWidth = $nav.find('.c-nav__logo').outerWidth(true);
            var width = containerW - logoOuterWidth - 6; // Same calculation as search field
            
            // Ensure we have a valid width before setting
            if (width > 0) {
                $autocomplete.css('width', width + 'px');
            } else {
                // Fallback: use 100% if calculation fails
                $autocomplete.css('width', '100%');
            }
        }
    }

}

export default init;